// Tim Hortons doesn't show the menu carousel
export default function MainMenuCarousel() {
  return null;
}
